import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { Waypoint } from "react-waypoint";

import { selectFavoriteIds } from "../../../routes/Favorite/favorite.ducks";
import { SimilarAdCard } from "../../../components/SimilarAdCard";
import AdList from "../../../components/AdList";
import styles from "./discountedAdsSection.scss";
import { AdCard } from "../../../components/AdCard";
import { clearDiscountedAds, getDiscountedAds, selectDiscountedAds } from "../../../routes/Ad/ad.ducks";
import { LinkTargetEnum, ModuleName, PageRoute, AdsSortOption, QueryParam } from "../../../models";
import { doesCategoryExist } from "../../../routes/LanguageMapper";
import { stringifyURI, getUrlParams } from "../../../services";

function DiscountedAdsSection(props: any) {
  const {
    ads,
    isMobile,
    className,
    renderGoogleAds,
    showDetails,
    module,
    favoriteIds,
    location,
    getDiscountedAds,
    clearDiscountedAds,
    category,
    categoryLv1Ids
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [hasTrackedViewport, setHasTrackedViewport] = useState(false);
  const history = useHistory();
  const routerLocation = useLocation();

  useEffect(() => {
    setIsLoading(true);
    loadData();

    return () => {
      clearDiscountedAds();
    };
  }, [
    location,
    module,
    favoriteIds,
    categoryLv1Ids
  ]);


  const loadData = async () => {

    const queryParams: any = {
      ...(module && { module }),
      ...(category && { category }),
      ...(categoryLv1Ids && { categoryLv1Ids: categoryLv1Ids }) 
    };

    await getDiscountedAds(
      favoriteIds,
      undefined,
      4,
      module,
      queryParams
    );

    setIsLoading(false);
  };

  const trackDiscountedAdClick = () => {
    ReactGA.event({
      category: "Oglasi na popustu - widget",
      action: "Click",
      label: "Naslovnica"
    });
  };

  const trackDiscountedWidgetInViewport = () => {
    if (!hasTrackedViewport) {
      ReactGA.event({
        category: "Oglasi na popustu - widget",
        action: "In Viewport",
        label: "Widget Viewed"
      });
      setHasTrackedViewport(true);
    }
  };

  const handleShowAllClick = () => {
    // Track the "Show All" click
    trackDiscountedAdClick();

    // Navigate to search page with withReducedPrice filter and current module/category
    const searchParams = {
      withReducedPrice: true,
      module: module,
      ...(category && doesCategoryExist(category) && { category }),
      ...(categoryLv1Ids && { categoryLv1Ids: [categoryLv1Ids] }),
    };

    // Construct URL from current location
    const basePath = routerLocation.pathname.replace(/\/pretraga.*$/, ''); // Remove existing search path

    history.push(`${basePath}${PageRoute.search}${stringifyURI(searchParams, "searchQuery")}`);
  };

  // if ads are empty, don't display the section
  if (!ads || (ads && ads.data && !(ads.data.length >= 4))) {
    return null;
  }


  return (
    <Waypoint onEnter={trackDiscountedWidgetInViewport}>
      <div className={`${styles.container} ${className}`}>
        <div className={styles.title}>Oglasi sa sniženom cijenom</div>
        {/* 
      // @ts-ignore */}
        <AdList
          ads={ads ? ads.data : []}
          adCardProps={{
            hasFavorite: true,
            adLists: { discountedAds: ads || {} },
            isMobile,
            className: isMobile ? styles.cardMobile : styles.cardDesktop,
            target: LinkTargetEnum.blank,
            onClick: () => trackDiscountedAdClick()
          }}
          renderGoogleAds={renderGoogleAds}
          AdCardComponent={isMobile ? AdCard : SimilarAdCard}
          responsiveProps={{ xs: 24, sm: 12, md: 12, lg: 12, xl: 8, xxl: 6 }}
          gutter={isMobile ? 0 : 20}
          showDetails={showDetails}
          isLoading={isLoading}
        />
        <div className={styles.showAllButtonContainer}>
          <Button
            className={styles.showAllButton}
            onClick={handleShowAllClick}
          >
            {"Prikaži sve"}
          </Button>
        </div>
      </div>
    </Waypoint>
  );
}

DiscountedAdsSection.defaultProps = {
  ads: {},
  favoriteIds: undefined,
  isMobile: false,
  className: "",
  module: null,
  renderGoogleAds: () => null,
  category: undefined
};

function mapStateToProps(state) {
  return {
    ads: selectDiscountedAds(state),
    favoriteIds: selectFavoriteIds(state),
    location: state.router.location
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDiscountedAds: (
      favoriteIds,
      undefined,
      itemPerPage,
      module,
      queryParams
    ) =>
      dispatch(
        getDiscountedAds({
          favoriteIds,
          undefined,
          itemPerPage,
          module,
          queryParams
        })
      ),
    clearDiscountedAds: () => dispatch(clearDiscountedAds())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscountedAdsSection);


// WEBPACK FOOTER //
// ./src/containers/ModulePage/DiscountedAdsSection/DiscountedAdsSection.tsx